import classnames from 'classnames';
import { type CSSProperties, type FunctionComponent } from 'react';

import { CopperDot } from '@/domains/core/tamagoshi/colorDots/CopperDot/CopperDot';
import { GoldDot } from '@/domains/core/tamagoshi/colorDots/GoldDot/GoldDot';
import { MulticolorDot } from '@/domains/core/tamagoshi/colorDots/MulticolorDot/MulticolorDot';
import { OtherDot } from '@/domains/core/tamagoshi/colorDots/OtherDot/OtherDot';
import { SilverDot } from '@/domains/core/tamagoshi/colorDots/SilverDot/SilverDot';
import { TransparentDot } from '@/domains/core/tamagoshi/colorDots/TransparentDot/TransparentDot';

import { ColorGroup, Colors, SpecificColors } from '../../../interfaces';
import { COLORS_MAPPING } from '../constants';

import dotColorStyles from './DotColor.module.scss';

const colorsIcon: {
  [key in SpecificColors]?: JSX.Element;
} = {
  [SpecificColors.Multicolor]: <MulticolorDot />,
  [SpecificColors.Transparent]: <TransparentDot />,
  [SpecificColors.Silver]: <SilverDot />,
  [SpecificColors.Golden]: <GoldDot />,
  [SpecificColors.Copper]: <CopperDot />,
};

interface DotColorProps {
  colorName: string;
  checkbox?: boolean;
  styles?: CSSProperties;
}

export const DotColor: FunctionComponent<DotColorProps> = ({
  colorName,
  checkbox = false,
  styles,
}) => {
  const currentColor = COLORS_MAPPING[colorName as ColorGroup];
  const isHexaColor = currentColor?.indexOf('#') === 0;

  const dotClassNames = classnames(dotColorStyles.colorPattern, {
    [dotColorStyles.checkbox]: checkbox,
    [dotColorStyles.withBorder]:
      colorName === Colors.White || colorName === SpecificColors.Other,
  });

  return (
    <div
      className={dotClassNames}
      style={{
        ...(isHexaColor && { backgroundColor: currentColor }),
        ...styles,
      }}
    >
      {!isHexaColor
        ? colorsIcon[currentColor as SpecificColors] || <OtherDot />
        : null}
    </div>
  );
};

DotColor.displayName = 'DotColor';
